const guildContentCache = (guildId, isSignedIn = false, context = {}) => (
  !context.canView || !guildId
    ? null
    : !isSignedIn
      ? `guild-content-viewers:${guildId}`
      : context.isProposedMember
        ? `guild-content-supporters:${guildId}`
        : !context.isMember
          ? `guild-content-network:${guildId}`
          : ['contributor', 'organizer', 'point'].includes(context.role)
            ? `guild-content-contributors:${guildId}`
            : `guild-content-supporters:${guildId}`
);

/**
 * Either returns an empty array or an array with two cacheIds:
 * - FIRST ITEM: guildContentCache
 * - SECOND ITEM: all-members-search
 */
const guildDetailViewCaches = (guildId, isSignedIn = false, context = {}) => {
  if (!context.canView) return [];

  const caches = [guildContentCache(guildId, isSignedIn, context)];

  if (isSignedIn && context.visibleData?.includes?.('member-list'))
    caches.push('all-members-search');

  return caches;
};

export {
  guildContentCache,
  guildDetailViewCaches,
};
